export default __webpack_public_path__ + "static/media/loginphoto.c225affa.png";